




































import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'EmailPreview',
  props: {
    show: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    submitText: {
      type: String,
    },
  },
  data() {
    return {
      address: '',
    };
  },
});
